import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from 'devextreme-react/button';
import { Column } from 'devextreme-react/gantt';
import { DateBox, Template } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import SplitterLayout from 'react-splitter-layout';
import DataGridMVP from '../DataGridMVP';
import columnDataGridTtn from './columnDataGridTtn';
import PopupMVP from '../PopupMVP';
import { normalizeDateToSend } from '../../utils/functions';
import columnDataGridPiece from './columnDataGridPiece';
import columnDataGridPieceByStock from './columnDataGridPieceByStock';
import HeaderButtonMVP from '../HeaderButtonMVP';
import styles from '../ModalTN/modaltn.module.scss';
import SimpleDataGrid from '../SimpleDataGrid';

const docNumIdsDefault = [];
const initialModalVisibleState = {
  confirm: false,
  delete: false,
  addPiece: false,
  deletePiece: false
};
const EditTtn = ({
  tnReducer: {
    addPiece: addPieceState,
    confirmTn: confirmTnState,
    deletePiece: deletePieceState,
    deleteTn: deleteTnState,
    tnList,
    tnPieceList,
    updateTn: updateTnState,
    visibleModal
  },
  tabsReducer: { tabSelect },
  documentsReducer: { piecesByStock },
  addPieceToTn,
  confirmTn,
  deletePieceFromTn,
  deleteTn,
  getPiecesByStock,
  getTnList,
  getTnPieceList,
  modalTNOpen,
  plantId,
  setInitialStateTn,
  setTn
}) => {
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  const [thisDataGridPieceInstance, setThisDataGridPieceInstance] = useState({});
  const [modalVisible, setModalVisible] = useState(initialModalVisibleState);
  const [dataSource, setDataSource] = useState({ selectList: [] });
  const [dataSourcePiece, setDataSourcePiece] = useState({ selectList: [] });
  const [pieceData, setPieceData] = useState('');
  const [docNumIds, setDocNumIds] = useState(docNumIdsDefault);
  const [confirmTtnDate, setConfirmTtnDate] = useState('');
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: ''
  });
  const [filterDataGridPiece, setFilterDataGridPiece] = useState({
    filter: ''
  });
  const [ttnData, setTtnData] = useState({
    docStatus: '',
    ttnDocumentDate: '',
    ttnDocumentId: '',
    ttnDocumentNumId: ''
  });

  const handleCloseModal = useCallback(() => {
    setModalVisible(initialModalVisibleState);
  }, []);

  // Получение списка ТН
  const getList = useCallback(() => {
    getTnList({
      ...filterDataGrid,
      plantId,
      itemList: []
    });
  }, [filterDataGrid, getTnList, plantId]);

  // Получение списка СК
  const getPieceList = useCallback(() => {
    if (dataSource.selectList.length && dataSource.selectList[0].ttnDocumentNumId) {
      getTnPieceList({
        itemList: [dataSource.selectList[0].ttnDocumentNumId],
        filter: filterDataGridPiece.filter,
        plantId
      });
    }
  }, [dataSource.selectList, filterDataGridPiece.filter, getTnPieceList, plantId]);

  const handleDeleteTn = useCallback(() => {
    if (ttnData.ttnDocumentNumId) {
      deleteTn({ ttnDocumentNumId: ttnData.ttnDocumentNumId });
    }
  }, [deleteTn, ttnData.ttnDocumentNumId]);

  // Добавление СК в ТН
  const handleAddPiece = useCallback(() => {
    if (pieceData.length) {
      addPieceToTn({
        docNumId: ttnData.ttnDocumentNumId,
        items: pieceData.map(({ pieceNumId }) => pieceNumId)
      });
    }
  }, [
    pieceData,
    addPieceToTn,
    ttnData
  ]);

  // Удаление СК из ТН
  const handleDeletePiece = useCallback(() => {
    deletePieceFromTn({
      docNumId: ttnData.ttnDocumentNumId,
      items: dataSourcePiece.selectList.map(({ pieceNumId }) => pieceNumId)
    });
  }, [dataSourcePiece.selectList, deletePieceFromTn, ttnData.ttnDocumentNumId]);

  // Подтверждение ТН
  const handleConfirmTn = useCallback(() => {
    const payload = {
      ttnData: dataSource.selectList,
      newDate: confirmTtnDate,
      docStatus: 3,
      pKeys: docNumIds
    };
    confirmTn(payload);
  }, [confirmTn, dataSource.selectList, docNumIds, confirmTtnDate]);

  // Закрытие модалок ТН после успешного запроса
  useEffect(() => {
    if (
      confirmTnState.success
      || tnList.okUpdate
      || (updateTnState.updateByModal ? false : updateTnState.success)
      || deleteTnState.success
    ) {
      thisDataGridInstance.instance.clearSelection();
      getList();
      handleCloseModal();
    }
  }, [
    confirmTnState,
    deleteTnState,
    getList,
    handleCloseModal,
    thisDataGridInstance.instance,
    tnList.okUpdate,
    updateTnState
  ]);

  // обновление списка после обновления ТН
  useEffect(() => {
    if (updateTnState.updateTnFromTab && !visibleModal.TN) {
      setInitialStateTn();
      getList();
      handleCloseModal();
    }
  }, [
    getList,
    handleCloseModal,
    setInitialStateTn,
    updateTnState.updateTnFromTab,
    visibleModal.TN
  ]);

  // Закрытие модалок СК после успешного запроса
  useEffect(() => {
    if (addPieceState.success || deletePieceState.success) {
      thisDataGridPieceInstance.instance.clearSelection();
      getPieceList();
      handleCloseModal();
    }
  }, [
    addPieceState,
    deletePieceState,
    handleCloseModal,
    getPieceList,
    thisDataGridPieceInstance.instance
  ]);

  // Получение списка ТН
  useEffect(() => {
    if (tabSelect === 12 && plantId !== null) {
      getList();
    }
  }, [getList, plantId, tabSelect]);

  // Получение списка СК
  useEffect(() => {
    if (tabSelect === 12 && dataSource.selectList.length && dataSource.selectList.length === 1) {
      getPieceList();
    }
  }, [dataSource.selectList, tabSelect, getPieceList]);

  // Получение списка УЕ
  useEffect(() => {
    if (tabSelect === 12 && modalVisible.addPiece) {
      getPiecesByStock({
        docType: ttnData.docTypeNumId,
        plantId
      });
    }
  }, [
    getPiecesByStock,
    modalVisible.addPiece,
    plantId,
    tabSelect,
    ttnData.docTypeNumId
  ]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid({
        filter: value
      });
    }
  }, []);

  /** Поисковая строка СК */
  const dataGridOnOptionChangedPiece = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGridPiece({
        filter: value
      });
    }
  }, []);

  // Выбор элементов ТН
  const onSelectionChanged = useCallback(({ selectedRowsData }) => {
    if (selectedRowsData.length && selectedRowsData.length === 1) {
      setTtnData({ ...selectedRowsData[0] });
      setDocNumIds(docNumIdsDefault);
    } else if (selectedRowsData.length && selectedRowsData.length > 1) {
      setDocNumIds(selectedRowsData.map(({ ttnDocumentNumId }) => ttnDocumentNumId));
    }
    setDataSource({
      selectList: selectedRowsData
    });
  }, []);

  // Выбор элементов СК
  const onSelectionChangedPiece = useCallback(({ selectedRowsData }) => {
    setDataSourcePiece({
      selectList: selectedRowsData
    });
  }, []);

  const onSelectionChangedPieceByStock = useCallback(({ selectedRowsData }) => {
    setPieceData(selectedRowsData);
  }, []);

  const openConfirmTnModal = useCallback(() => {
    setModalVisible((prevState) => ({
      ...prevState,
      confirm: true
    }));
  }, []);

  const openEditTnModal = useCallback(() => {
    setTn({
      ...ttnData,
      dateTn: ttnData.ttnDocumentDate,
      docNum: ttnData.ttnDocumentId,
      docNumId: ttnData.ttnDocumentNumId,
      updateTnFromTab: true
    });
    modalTNOpen({
      updateTnFromTab: true
    });
  }, [modalTNOpen, setTn, ttnData]);

  const openDeleteTnModal = useCallback(() => {
    setModalVisible((prevState) => ({
      ...prevState,
      delete: true
    }));
  }, []);

  const openUpdateAddPiece = useCallback(() => {
    setModalVisible((prevState) => ({
      ...prevState,
      addPiece: true
    }));
  }, []);

  const openUpdateDeletePiece = useCallback(() => {
    setModalVisible((prevState) => ({
      ...prevState,
      deletePiece: true
    }));
  }, []);

  // параметры для отключения кнопок "Редактировать" и "Удалить" для ТН
  const getButtonDisableParams = useMemo(() =>
    !dataSource.selectList.length
      || dataSource.selectList.length > 1
      || dataSource.selectList[0].docStatus === 3
      || dataSource.selectList[0].docStatus === 4, [dataSource]);

  // параметры для отключения кнопки "Добавить" в УЕ
  const getButtonPieceDisableParams = useMemo(() =>
    !dataSource.selectList.length
      || dataSource.selectList[0].docStatus === 3
      || dataSource.selectList[0].docStatus === 4, [dataSource]);

  // параметры для отключения кнопки "Удалить" в УЕ
  const getButtonPieceDeleteDisableParams = useMemo(() =>
    !dataSource.selectList.length
    || dataSource.selectList[0].docStatus === 3
    || dataSource.selectList[0].docStatus === 4
    || !dataSourcePiece.selectList.length, [dataSource, dataSourcePiece]);

  /** Рендер кнопки редактирования ТН */
  const toolbarButtonEditTn = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').edit}
      type={'default'}
      stylingMode={'contained'}
      disabled={getButtonDisableParams}
      onClick={openEditTnModal}
    />
  ), [getButtonDisableParams, openEditTnModal]);

  /** Рендер кнопки удаления ТН */
  const toolbarButtonDeleteTn = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').delete}
      type={'danger'}
      stylingMode={'contained'}
      disabled={getButtonDisableParams}
      onClick={openDeleteTnModal}
    />
  ), [getButtonDisableParams, openDeleteTnModal]);

  /** Рендер кнопки удаления ТН */
  const toolbarButtonConfirmTn = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').confirm}
      style={{ display: dataSource.selectList.length && dataSource.selectList.length > 1 ? 'block' : 'none' }}
      type={'default'}
      stylingMode={'contained'}
      disabled={!dataSource.selectList.every((tn) => tn.docStatus === 2)}
      onClick={openConfirmTnModal}
    />
  ), [dataSource.selectList, openConfirmTnModal]);

  // Рендер кнопок для взаимодействия с УЕ
  const renderHeaderPiece = useMemo(() => (
    <HeaderButtonMVP
      headButtVisibol={{
        display: 'flex',
        width: '50%'
      }}
    >
      {ttnData.docStatus !== 4 && (
        <Button
          text={formatMessage('textButton').add}
          type={'default'}
          stylingMode={'contained'}
          onClick={openUpdateAddPiece}
          disabled={getButtonPieceDisableParams}
        />
      )}
      <Button
        text={formatMessage('textButton').remove}
        type={'danger'}
        stylingMode={'contained'}
        onClick={openUpdateDeletePiece}
        disabled={getButtonPieceDeleteDisableParams}
      />
    </HeaderButtonMVP>
  ), [
    getButtonPieceDeleteDisableParams,
    getButtonPieceDisableParams,
    openUpdateAddPiece,
    openUpdateDeletePiece,
    ttnData.docStatus
  ]);

  // Модальное окно подтверждения ТН
  const renderModalTtnConfirm = useMemo(() => (
    <PopupMVP
      title={formatMessage('textModal').confirmTn}
      visible={modalVisible.confirm}
      onHiding={handleCloseModal}
    >
      <div className="formData">
        <div className="optionsRow">
          {`${formatMessage('textModal').textConfirmTn} № ${dataSource.selectList.map(({ ttnDocumentId }) => (ttnDocumentId)).join(', ')} ?`}
        </div>
        <div className="optionsData">
          <span>{formatMessage('textData').actualShippingDate}</span>
          <DateBox
            type="date"
            displayFormat="dd.MM.yyyy"
            value={confirmTtnDate}
            isValid={!!confirmTtnDate}
            onValueChanged={({ value }) => setConfirmTtnDate(normalizeDateToSend(value))}
            width="100%"
            stylingMode="outlined"
            openOnFieldClick
            useMaskBehavior
          />
        </div>
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={handleCloseModal}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            disabled={!confirmTtnDate}
            onClick={handleConfirmTn}
          >
            <LoadIndicator
              className="indicator"
              visible={confirmTnState.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    modalVisible.confirm,
    handleCloseModal,
    dataSource.selectList,
    confirmTtnDate,
    handleConfirmTn,
    confirmTnState.loading]);

  // Модальное окно удаления ТН
  const renderModalTtnDelete = useMemo(() => (
    <PopupMVP
      title={formatMessage('textModal').deleteTn}
      visible={modalVisible.delete}
      onHiding={handleCloseModal}
    >
      <div className="formData">
        {`${formatMessage('textModal').textDeleteTn} № ${ttnData.ttnDocumentId} ?`}
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={handleCloseModal}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            onClick={handleDeleteTn}
          >
            <LoadIndicator
              className="indicator"
              visible={deleteTnState.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    deleteTnState.loading,
    handleCloseModal,
    handleDeleteTn,
    modalVisible.delete,
    ttnData.ttnDocumentId
  ]);

  // Модально окно добавления УЕ
  const renderModalAddPiece = useMemo(() => (
    <PopupMVP visible={modalVisible.addPiece}
              onHiding={handleCloseModal}
              title={formatMessage('textModal').addPiece}
              height="auto"
    >
      <div className="formData">
        <div className="optionsData">
          <span>{formatMessage('textModal').listPiece}</span>
          <SimpleDataGrid scrollingMode="standard"
                          className={styles.pieceListGrid}
                          dataSource={piecesByStock}
                          visibleGroupPanel={false}
                          visibleFilter={false}
                          visibleFilterPanel={false}
                          onSelectionChanged={onSelectionChangedPieceByStock}
            >
            {columnDataGridPieceByStock.map((item) => (
              <Column dataField={item.dataField}
                      caption={formatMessage('textTable')[item.dataField]}
                      visible={!item.notVisible}
                      allowSearch
                      allowFiltering
                      key={item.dataField}
                      dataType={item.dataType}
                      width={item.width ? item.width : undefined}
                />
            ))}
          </SimpleDataGrid>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={handleCloseModal}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={handleAddPiece}
                  width={200}
                  disabled={!pieceData.length}
          >
            <LoadIndicator className="indicator" visible={addPieceState.loading} />
            <span>{formatMessage('textButton').addReady}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    addPieceState.loading,
    handleAddPiece,
    handleCloseModal,
    modalVisible.addPiece,
    pieceData,
    piecesByStock,
    onSelectionChangedPieceByStock
  ]);

  // модальное окно удаления УЕ
  const renderModalDeletePiece = useMemo(() => (
    <PopupMVP visible={modalVisible.deletePiece}
              onHiding={handleCloseModal}
              title={formatMessage('textModal').deletePiece}
    >
      <div className="formData">
        {`${formatMessage('textModal').youSure}?`}
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={handleCloseModal}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            onClick={handleDeletePiece}
          >
            <LoadIndicator
              className="indicator"
              visible={deletePieceState.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [deletePieceState.loading, handleCloseModal, modalVisible.deletePiece, handleDeletePiece]);

  // таблица УЕ
  const renderPieceTable = useMemo(
    () => (
      <>
        {renderHeaderPiece}
        <DataGridMVP dataSource={tnPieceList.data}
                     keyExpr="pieceNumId"
                     className="shipment"
                     setStateStoringName={'dataGridTnPiecesData'}
                     onSelectionChanged={onSelectionChangedPiece}
                     filterDataGrid={filterDataGridPiece}
                     setFilterDataGrid={setFilterDataGridPiece}
                     dataGridOnOptionChanged={dataGridOnOptionChangedPiece}
                     showBorders
                     visibleButtonDateRangePicker={false}
                     visibleInfoIcon={false}
                     visibleSummary={false}
                     visibleGroupPanel={false}
                     isDataLoading={tnPieceList.loading}
                     setDataGridInstance={setThisDataGridPieceInstance}
        >
          {columnDataGridPiece.map((item) => (
            <Column
              dataField={item.dataField}
              caption={formatMessage('textTnColumn')[item.dataField]}
              visible={!item.notVisible}
              allowSearch
              allowFiltering
              cellRender={item.cellRender}
              key={item.dataField}
              dataType={item.dataType}
              cssClass={item.cssClass}
              width={item.width ? item.width : undefined}
            />
          ))}
        </DataGridMVP>
      </>
    ),
    [
      renderHeaderPiece,
      tnPieceList,
      onSelectionChangedPiece,
      filterDataGridPiece,
      dataGridOnOptionChangedPiece
    ]
  );

  const renderTtnTable = useMemo(() => (
    <>
      <DataGridMVP dataSource={tnList.data}
                   keyExpr="ttnDocumentNumId"
                   className="shipment"
                   setDataGridInstance={setThisDataGridInstance}
                   setStateStoringName={'dataGridTtnData'}
                   onSelectionChanged={onSelectionChanged}
                   filterDataGrid={filterDataGrid}
                   setFilterDataGrid={setFilterDataGrid}
                   dataGridOnOptionChanged={dataGridOnOptionChanged}
                   showBorders
                   loadingData={tnList.loading}
                   loading={tnList.loading}
                   onClickUpdate={getList}
                   visibleButtonConfirmTn
                   visibleButtonDeleteTn
                   visibleButtonEditTn
                   visibleInfoIcon={false}
                   visibleSummary={false}
                   visibleGroupPanel={false}
                   visibleButtonUpdate
                   shrinkToolbar
      >
        {columnDataGridTtn.map((item) => (
          <Column dataField={item.dataField}
                  allowSearch={item.allowSearch}
                  caption={formatMessage('textTnColumn')[item.dataField]}
                  visible={!item.notVisible}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
                  width={item.width ? item.width : undefined}
                  cellRender={item.cellRender}
          />
        ))}
        <Template name="toolbarButtonDeleteTn" render={toolbarButtonDeleteTn} />
        <Template name="toolbarButtonEditTn" render={toolbarButtonEditTn} />
        <Template name="toolbarButtonConfirmTn" render={toolbarButtonConfirmTn} />
      </DataGridMVP>
    </>
  ), [
    dataGridOnOptionChanged,
    filterDataGrid,
    tnList,
    onSelectionChanged,
    getList,
    toolbarButtonDeleteTn,
    toolbarButtonEditTn,
    toolbarButtonConfirmTn
  ]);

  return (
    <>
      <SplitterLayout percentage primaryMinSize={20} secondaryInitialSize={50}>
        <div className={styles.topSide}>
          {renderTtnTable}
        </div>
        <div className={styles.bottomSide}>
          {renderPieceTable}
        </div>
      </SplitterLayout>
      {renderModalTtnConfirm}
      {renderModalAddPiece}
      {renderModalDeletePiece}
      {renderModalTtnDelete}
    </>
  );
};

export default React.memo(EditTtn);
